import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { injectIntl, intlShape } from "@ai360/core/intl";
import classnames from "classnames";
import * as layerSelectors from "../layer-list/selectors";
import { RecEventItem } from "~/action-panel/components/common/accordion/rec-event-accordion-item";
import { RecEventInfo } from "~/action-panel/components/common/rec-event-info/rec-event-info";
import { Pane, Loader } from "~/core";

import * as actions from "./actions";
import * as imageryForm from "./imagery-form";
import * as selectors from "./selectors";
import { CustomerAPI, FieldAPI, LayerAPI } from "@ai360/core";

interface IImageryFormLabelProps {
    hasError: boolean;
    intl: intlShape;
    labelIconEl: Element;
    labelMessage: string;
}

export class FormLabel_ extends PureComponent<IImageryFormLabelProps> {
    render() {
        const { hasError, labelIconEl, labelMessage } = this.props;
        const { formatMessage } = this.props.intl;

        return (
            <div
                className={classnames("rec-event-info-tab-label", {
                    "has-error": hasError,
                })}
            >
                {labelIconEl}
                <div className="tab-nav-text">{formatMessage(labelMessage)}</div>
            </div>
        );
    }
}

export const FormLabel = injectIntl(FormLabel_);

interface IImageryLayerProps {
    fieldImageryLayers: LayerAPI.ISubLayer[];
    imageryLayerSummary: LayerAPI.IImageryLayerSummary;
    customer: CustomerAPI.ICustomer;
    enableSave: boolean;
    field: FieldAPI.IField;
    intl: intlShape;
    isLoading: boolean;
    onClose: () => void;
    onSaveChanges: () => void;
}

export class ImageryLayer_ extends PureComponent<IImageryLayerProps> {
    _getEventStripItem() {
        const { imageryLayerSummary, isLoading } = this.props;
        if (isLoading) {
            return (
                <div className="item-container">
                    <Loader />;
                </div>
            );
        }
        const { croppingSeasonName, imageDate } = imageryLayerSummary;
        const itemProps = {
            displayName: ["Imagery ", croppingSeasonName, imageDate]
                .filter((v) => v && v !== "")
                .join("- "),
            summary: imageryLayerSummary.name,
            contextMenu: null,
            deselectItemsFromDimIdx: () => null,
            isExpanded: false,
            itemDimIdx: [],
            lastClickedDimIdx: [],
            setLastClickedDimIdx: () => null,
            selectItemsFromDimIdx: () => null,
            isSelected: true,
        };
        return (
            <div className="item-container">
                <RecEventItem {...itemProps} />
            </div>
        );
    }

    _getPanes() {
        const panes = [];
        const { fieldImageryLayers, imageryLayerSummary, isLoading } = this.props;
        const [EventEditForm, labelMessage, LabelIcon] = [
            imageryForm.ImageryForm,
            imageryForm.formLabelMessage,
            imageryForm.formLabelIcon,
        ];
        const label = (
            <FormLabel
                canRemove={false}
                hasError={false}
                labelMessage={labelMessage}
                labelIconEl={<LabelIcon />}
            />
        );
        const imageryProps = { fieldImageryLayers, imageryLayerSummary };
        panes.push(
            <Pane key={"imagery"} label={label}>
                {isLoading ? <Loader /> : <EventEditForm {...imageryProps} />}
            </Pane>
        );
        return panes;
    }

    render() {
        const { enableSave, isLoading, onClose, onSaveChanges } = this.props;

        return (
            <RecEventInfo
                addItemTitle={""}
                enableSave={enableSave}
                errorCodeList={[]}
                eventRecItemStrip={this._getEventStripItem()}
                informationPanes={this._getPanes()}
                isBatchTemplate={false}
                isLoading={isLoading}
                isNew={false}
                addMenuItems={[]}
                canAddEvent={false}
                onSave={onSaveChanges}
                onCancel={onClose}
            />
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    onClose: () => dispatch(actions.closeImageryLayer()),
    onSaveChanges: () => dispatch(actions.saveImageryLayer()),
});

const mapStateToProps = (state) => {
    const imageryState = selectors.getModuleState(state);

    const { imageryLayerSummary, isLoading } = imageryState;

    const fieldImageryLayers = [];
    const layerInfos = layerSelectors.getLayerInfos(state);

    for (const layers of layerInfos.values()) {
        const imageryPresent = layers.some(
            (li) => li.imageryLayerGuid === imageryLayerSummary.imageryLayerGuid
        );

        if (imageryPresent) {
            Object.entries(layers).forEach(([, value]) => {
                if ((value as any).layerType === "Imagery") {
                    fieldImageryLayers.push(value);
                }
            });
        }
    }

    const enableSave =
        !isLoading &&
        imageryLayerSummary.name &&
        imageryLayerSummary.croppingSeasonGuid &&
        imageryLayerSummary.imageDate;

    return {
        fieldImageryLayers,
        imageryLayerSummary,
        enableSave,
        isLoading,
    };
};

export const ImageryLayer = connect(mapStateToProps, mapDispatchToProps)(injectIntl(ImageryLayer_));
